class PattaProductStories extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.dialog = this.querySelector('dialog');
    this.panels = [...this.querySelectorAll('[data-story-panel]')];
    this.progress = [...this.querySelectorAll('.patta-story-viewer__progress span')];
    this.index = 0;

    this.querySelectorAll('[data-story-open]').forEach(button => {
      button.addEventListener('click', () => this.open(Number(button.dataset.storyOpen), button));
    });
    this.querySelector('[data-story-close]')?.addEventListener('click', () => this.close());
    this.querySelector('[data-story-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('[data-story-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.dialog?.addEventListener('click', event => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog?.addEventListener('close', () => this.cleanup());
    this.dialog?.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') this.show(this.index + 1);
      if (event.key === 'ArrowLeft') this.show(this.index - 1);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.pauseMedia();
    });
  }

  open(index, trigger) {
    this.trigger = trigger;
    this.dialog?.showModal();
    document.documentElement.classList.add('overflow-hidden');
    this.show(index);
  }

  show(index) {
    if (!this.panels.length) return;
    this.pauseMedia();
    this.index = (index + this.panels.length) % this.panels.length;
    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== this.index;
    });
    this.panels[this.index]?.querySelectorAll('img').forEach(image => {
      image.loading = 'eager';
    });
    this.progress.forEach((segment, segmentIndex) => {
      segment.classList.toggle('is-complete', segmentIndex < this.index);
      segment.classList.toggle('is-active', segmentIndex === this.index);
    });
    const video = this.panels[this.index]?.querySelector('video');
    video?.play().catch(() => {});
  }

  pauseMedia() {
    this.querySelectorAll('video').forEach(video => video.pause());
  }

  close() {
    this.dialog?.close();
  }

  cleanup() {
    this.pauseMedia();
    document.documentElement.classList.remove('overflow-hidden');
    this.trigger?.focus();
  }
}

if (!customElements.get('patta-product-stories')) {
  customElements.define('patta-product-stories', PattaProductStories);
}
